import { render } from "./CatalogGrid.vue?vue&type=template&id=c20a488e"
import script from "./CatalogGrid.vue?vue&type=script&lang=js"
export * from "./CatalogGrid.vue?vue&type=script&lang=js"

import "./CatalogGrid.vue?vue&type=style&index=0&id=c20a488e&lang=scss"
script.render = render

export default script